import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Alert, Stack, Typography } from '@mui/material';
import { useCreateFolderMutation } from '~/api/v2/hooks';
import { ModalTypeEnum } from '~/components';
import BreadcrumbsNavigation from '~/components/BreadcrumbsNavigation';
import { CreateFolderPayload } from '~/components/FileSystemActionModal';
import { HomeIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { FolderTree } from '.';
import { alertStyles } from './styles';

const StoragePage = () => {
  const dispatch = useAppDispatch();
  const [createFolder] = useCreateFolderMutation({ fixedCacheKey: 'create-folder' });

  return (
    <>
      <BreadcrumbsNavigation
        navigationConfig={[
          { name: <HomeIcon />, path: '' },
          { name: 'My Storage', path: '.' },
        ]}
      />
      <Stack direction="row" justifyContent="space-between" pb={1}>
        <Typography variant="h3" my="1rem">
          My Storage
        </Typography>
        <CustomButton
          label="New Folder"
          buttonType="addNew"
          onClick={() => {
            dispatch(
              openModal({
                type: ModalTypesEnum.FILE_SYSTEM_ACTION,
                payload: {
                  type: ModalTypeEnum.CREATE,
                  onCreate: ({ folder_path }: Parameters<CreateFolderPayload['onCreate']>[0]) => {
                    createFolder({ folder_path });
                  },
                },
              }),
            );
          }}
        />
      </Stack>
      <Alert severity="info" sx={alertStyles}>
        A dedicated storage area allocated to each user to securely save and manage files.
        <b> Datasets cannot be uploaded to individual storage.</b>
      </Alert>
      <FolderTree />
    </>
  );
};

export default StoragePage;
